import { IHealthIndicatorProps } from "./types";
import { ReactElement } from "react";
import { useStyles } from "./HealthIndicator.styled";

export default function HealthIndicator({
  health,
  size,
}: IHealthIndicatorProps): ReactElement {
  const { classes } = useStyles({
    health,
    size,
  });

  return <div className={classes.root} />;
}
